/** QuickRouter — Aperçu d'un gabarit de carte, dessiné à partir du gabarit lui-même :
 *  carte mère en fantôme (pointillés), carte à créer (vert), connecteurs imposés. */
import { useMemo } from 'react';
import { templateById, makeLookup } from '../../shared/library/index.js';
import { courtyardPoly, polyBox } from '../../shared/geom.js';

const P = (pts) => pts.map(([x, y]) => `${x},${-y}`).join(' ');

export default function TemplatePreview({ id, params = {}, height = 150 }) {
  const view = useMemo(() => {
    const t = templateById(id);
    if (!t) return null;
    const values = Object.fromEntries(t.params.map((p) => [p.id, params[p.id] ?? p.default]));
    const built = t.build(values);
    const lookup = makeLookup(null);
    const comps = built.components
      .map((c) => {
        const fp = lookup(c.footprint);
        // Trou de fixation : dessiné en rond (pastille unique percée).
        const hole = fp?.pads.length === 1 && fp.pads[0].drill;
        return { c, poly: courtyardPoly({ side: 'top', rot: 0, ...c }, fp), r: hole ? Math.max(...fp.pads[0].size) / 2 : 0 };
      })
      .filter((x) => x.poly);
    const box = polyBox([...built.outline, ...(built.mother?.outline ?? [])]);
    return { built, comps, box };
  }, [id, JSON.stringify(params)]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!view) return null;
  const { built, comps, box } = view;
  const m = 3;
  const vb = `${box[0] - m} ${-box[3] - m} ${box[2] - box[0] + 2 * m} ${box[3] - box[1] + 2 * m}`;
  return (
    <svg className="tpl-preview" viewBox={vb} style={{ height }} preserveAspectRatio="xMidYMid meet">
      {built.mother && <polygon points={P(built.mother.outline)} fill="#1d3a66" fillOpacity="0.45" stroke="#7d9bd0" strokeWidth="0.8" strokeDasharray="3 2" />}
      <polygon points={P(built.outline)} fill="#16703b" fillOpacity="0.92" stroke="#f0d000" strokeWidth="0.8" />
      {comps.map(({ c, poly, r }) => (r
        ? <circle key={c.ref} cx={c.pos[0]} cy={-c.pos[1]} r={r} fill="#0b0b0b" stroke="#d9a520" strokeWidth="0.6" />
        : <polygon key={c.ref} points={P(poly)} fill="#d9a520" fillOpacity="0.85" />))}
    </svg>
  );
}
